import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';
import { ChamberMember, CodebookModel } from 'app/shared/model/shared.model';

export interface SiteConstructor {
  idSiteConstructor?: number;
  partyType?: CodebookModel[];
  person: PersonModel;
  legalEntity: LegalEntityModel;
  email?: string;
  telephoneNumber?: string;
  address: AddressModel;
  subjectType: CodebookModel[];
}

export interface SiteConstructorView {
  idSiteConstructor: number;
  oibMb: string;
  name?: string;
  address: string;
}

export const siteConstructorInitialData = {
  email: '',
  telephoneNumber: '+385',
  subjectType: [],
  person: {
    oib: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    address: null,
    subjectType: null,
  },
  legalEntity: {
    oib: '',
    mb: '',
    address: null,
    companyName: '',
    subjectType: null,
  },
  address: initialAddress,
};

export interface SiteSupervisorOffice {
  subjectType: CodebookModel[];
  legalEntity: LegalEntityModel;
  address: AddressModel;
}

export interface SiteSupervisor {
  idSiteSupervisor: number;
  chamberMember: ChamberMember;
  siteSupervisorOffice: SiteSupervisorOffice;
  email?: string;
  telephoneNumber?: string;
}

export const initialSiteSupervisorData = {
  chamberMember: {
    authorizationNumber: [],
    oib: '',
  },
  siteSupervisorOffice: {
    subjectType: [],
    legalEntity: {
      mb: '',
      oib: '',
      address: null,
      companyName: '',
      subjectType: [],
    },
    address: initialAddress,
  },
  email: '',
  telephoneNumber: '+385',
};

export interface SiteSupervisorView {
  idSiteSupervisor: number;
  authorizationNumber: number;
  name: string;
  oib: string;
  siteSupervisorOfficeName: string;
  siteSupervisorOfficeAddress: string;
}
